import appInsertIndex from '@/views/appInsert/appInsertIndex';

import schoolList from '@/views/schoolManage/schoolList';
import schoolListAbc from '@/views/schoolManage/schoolListAbc';
import schoolListCcb from '@/views/schoolManage/schoolListCcb';
import schoolAdd from '@/views/schoolManage/schoolAdd';
import schoolEdit from '@/views/schoolManage/schoolEdit';
import schoolDetail from '@/views/schoolManage/schoolDetail';
import schoolPermission from '@/views/schoolManage/schoolPermission';
import schoolGrant from '@/views/schoolManage/schoolGrant';
import schoolIntGrant from '@/views/schoolManage/schoolIntGrant';
import newOrderList from '@/views/schoolManage/newOrderList';
import activatingCodeList from '@/views/schoolManage/activatingCodeList';
import externalContact from '@/views/schoolManage/externalContact';

import schoolModuleRolePermissionList
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList';
import schoolModuleRolePermissionAdd
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd';
import schoolModuleRolePermissionEdit
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit';

import schoolRoleList from '@/views/schoolManage/schoolRole/schoolRoleList';
import schoolRoleEdit from '@/views/schoolManage/schoolRole/schoolRoleEdit';
import schoolRoleUserList from '@/views/schoolManage/schoolRole/schoolRoleUserList';

import schoolAppList from '@/views/schoolManage/schoolAppManage/schoolAppList';
import schoolAppInteDetail from '@/views/schoolManage/schoolAppManage/schoolAppInteDetail';

import schoolAdmin from '@/views/schoolManage/schoolAdmin';

import schoolSuite from '@/views/schoolManage/schoolSuite';

import promoteGrade from '@/views/schoolManage/promoteGrade';

export default [
    {
        path: 'customService',
        redirect: 'customService/schoolManage/schoolList'
    },
    {
        path: 'customService/appInsert/appInsertIndex',
        component: appInsertIndex
    },

    {
        path: 'customService/schoolManage/schoolList',
        component: schoolList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'customService/schoolManage/schoolListAbc',
        component: schoolListAbc,
        meta: {
            isCached: true
        }
    },
    {
        path: 'customService/schoolManage/schoolListCcb',
        component: schoolListCcb,
        meta: {
            isCached: true
        }
    },
    {
        path: 'customService/schoolManage/schoolAdd',
        component: schoolAdd
    },
    {
        path: 'customService/schoolManage/schoolEdit',
        component: schoolEdit
    },
    {
        path: 'customService/schoolManage/schoolDetail',
        component: schoolDetail
    },
    {
        path: 'customService/schoolManage/schoolPermission',
        component: schoolPermission
    },
    {
        path: 'customService/schoolManage/schoolGrant',
        component: schoolGrant
    },
    {
        path: 'customService/schoolManage/newOrderList',
        component: newOrderList
    },
    {
        path: 'customService/schoolManage/schoolIntGrant',
        component: schoolIntGrant
    },
    {
        path: 'customService/schoolManage/activatingCodeList',
        component: activatingCodeList
    },
    {
        path: 'customService/schoolManage/externalContact',
        component: externalContact
    },
    {
        path: 'customService/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList',
        component: schoolModuleRolePermissionList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'customService/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd',
        component: schoolModuleRolePermissionAdd
    },
    {
        path: 'customService/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit',
        component: schoolModuleRolePermissionEdit
    },
    {
        path: 'customService/schoolManage/schoolRole/schoolRoleList',
        component: schoolRoleList
    },
    {
        path: 'customService/schoolManage/schoolRole/schoolRoleEdit',
        component: schoolRoleEdit
    },
    {
        path: 'customService/schoolManage/schoolRole/schoolRoleUserList',
        component: schoolRoleUserList
    },
    {
        path: 'customService/schoolManage/schoolAppManage/schoolAppList',
        component: schoolAppList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'customService/schoolManage/schoolAppManage/schoolAppInteDetail',
        component: schoolAppInteDetail
    },
    {
        path: 'customService/schoolManage/schoolAdmin',
        component: schoolAdmin
    },
    {
        path: 'customService/schoolManage/schoolSuite',
        component: schoolSuite
    },
    {
        path: 'customService/schoolManage/promoteGrade',
        component: promoteGrade
    },
    {
        path: 'customService/schoolManage/activationcode',
        component: () => import('@/views/schoolManage/activationcode')
    },
    {
        path: 'customService/schoolManage/activationcodemylist',
        component: () => import('@/views/schoolManage/activationcodemylist')
    },
    {
        path: 'customService/schoolManage/activationcodedetail',
        component: () => import('@/views/schoolManage/activationcodedetail')
    },
    {
        path: 'customService/schoolManage/userRetrievalindex',
        component: () => import('@/views/userRetrieval/userRetrievalindex')
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/customService.js